import { UtilizationOptionValueType } from "./types"

export const TRACK_WIDTH_IN_METERS = 1.9

export const serializeOptionValue = (type: UtilizationOptionValueType, id: string) => `${type}__${id}`
export const parseOptionValue = (value: string) => {
  const [type, id] = value.split("__")
  return { type: type as UtilizationOptionValueType, id }
}
